import { type Struct } from 'superstruct';

export function handleResponse<T, S>(struct: Struct<T, S>) {
  return (response: Response) =>
    response.ok
      ? response.json().then(data => struct.mask(data))
      : response.text().then(text => Promise.reject(new Error(text)));
}
